import { useOrderStatusLabel } from 'hooks/business/chat/useOrder';
import dayjs from 'lib/dayjs';
import { CopyText } from '../CopyText';
import { useTranslate } from '@tolgee/react';

interface OrderStatusProps {
  tradeStatus: Conversation.Trade.Status;
  createTime: number | string;
  externalTradeId: Conversation.Trade.Vo['externalTradeId'];
}

export const OrderStatus = (props: OrderStatusProps) => {
  const { tradeStatus, createTime, externalTradeId } = props;
  const orderStatusLabel = useOrderStatusLabel(tradeStatus);
  const { t } = useTranslate();

  return (
    <div className="pt-4">
      <div className="flex items-center justify-between">
        <span className="text-[14px] text-[#232426] font-medium">{orderStatusLabel}</span>
      </div>
      <div className="mt-1 flex items-center justify-between text-[12px] text-[#84868C]">
        <CopyText text={externalTradeId} tooltip={t('订单编号')} showIcon />
        <span>{dayjs(Number(createTime)).format('YYYY-MM-DD, HH:mm')}</span>
      </div>
    </div>
  );
};
